import { uploadFile } from '../../../shared/api/uploadFile';

// Fase 5.16 (05-remediation.md) -- `UserProfilePanel.jsx` / `WhatsChatList.jsx` (presentacionales)
// tocaban `uploadFile` de `shared/api/*` y `localStorage` crudo. Acá:
//  - `uploadWhatsAvatar`: sube el avatar del contacto (tipo por defecto, devuelve `{ url }`).
export const uploadWhatsAvatar = (file) => uploadFile(file, 'profile');
